module.exports = __webpack_public_path__ + "static/media/checkbox-large-off.52864785.svg";